export const getColumnas = (user:any) =>{
return [
    {
        title:"Partes",
        key:"partes",
        show: true,
        columnas:[
            {id:"fecha", label:"Fecha"},
            {id:"estado", label:"Validación"},
            {id:"facturado", label:"Facturado"},
            {id:"sociedad", label:"Sociedad"},
            {id:"proyecto", label:"Proyecto"},
            {id:"funcion", label:"Función"},
            {id:"subFuncion", label:"SubFunción"},
            {id:"nHoras", label:"Horas Diarias"},
            {id:"desplazado", label:"Desplazado/a"},
            {id:"tieneAdjuntos", label:"Adjuntos"},
            {id:"observaciones", label:"Observaciones"}
        ]
    },
    {
        title:"Detalle Partes",
        key:"detallepartes",
        show: ((user.perfil!=='USR' && user.perfil!=='RRH') || (user.perfil==='USR' && user.controlUsuarios === true)) ? true : false,
        columnas:[
            {id:"fecha", label:"Fecha"},
            {id:"estado", label:"Validación"},
            {id:"facturado", label:"Facturado"},
            {id:"desplazado", label:"Desplazado"},
            {id:"fechaFacturacion", label:"Fecha Facturado"},
            {id:"dni", label:"Dni"},
            {id:"nombre", label:"Nombre"},
            {id:"direccionNegocio", label:"SG/DN"},
            {id:"area", label:"Area"},
            {id:"sociedad", label:"Sociedad"},
            {id:"pais", label:"Pais"},
            {id:"proyecto", label:"Proyecto"},
            {id:"funcion", label:"Función"},
            {id:"subFuncion", label:"SubFunción"},
            {id:"nHoras", label:"Horas Diarias"},
            {id:"tieneAdjuntos", label:"Adjuntos"},
            {id:"observaciones", label:"Observaciones"}
        ]
    }
]
}